import { ArrowLeftIcon, ArrowRightIcon, RightFillIcon, StarFillIcon, StarIcon } from "@t8891/icon";
import { IKindsPcInfo } from "@Types/kindsum";
import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { formatThousend } from "../../utils/helper";
import { useSetState } from "ahooks";
import { setUrlFormat } from "@Lib/common";
import { loginAtom } from "@Lib/jotai/login";
import { useAtom } from "jotai";
import { useMutation } from "react-query";
import { fakerUserFavorAdd } from "@Services/api";
import { Skeleton, Tooltip } from "antd";
import { host } from "@Services/url";
import PlaceHolderImage from "@Components/svgImage/placeholder";

const AttentionItem: React.FC<any> = ({ kindId, favorite }) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [loginInfo] = useAtom(loginAtom);

  const mutation = useMutation<void, unknown, any>(async (params) => {
    const res = await fakerUserFavorAdd(params);

    if (res?.status === "200") {
      setVisible(true);
      // message.success("關注成功");
    }
  });
  useEffect(() => {
    setVisible(favorite);
  }, [favorite]);
  return (
    <div
      className={`flex w-76 h-30 items-center bg-white rounded-4 text-14 cursor-pointer justify-center ${
        visible ? "" : "gap-6"
      }`}
      style={{ border: "1px solid #E8E8E8" }}
      onClick={() => {
        if (visible) return;
        if (!loginInfo) {
          window.location.href = `${host.www}/user-signin.html?url=${window.location.href}`;
        } else {
          const params = `[{ "type": "3", "id": "${kindId}" }]`;
          mutation.mutate({ data: params });
        }
      }}
    >
      {visible ? <StarFillIcon size={23} fill='#F7B500' /> : <StarIcon strokeWidth={2} size={23} fill='#BBB' />}
      <span>{visible ? "已關注" : "關注"}</span>
    </div>
  );
};

const Specification: React.FC<{ data: IKindsPcInfo }> = ({ data }) => {
  const { energyType, importantEquipSpecs, kindName, brandName } = data;
  const {
    airBag,
    autoType,
    batteryLife,
    electricConsumption,
    fuelConsumption,
    intake,
    gearBox,
    motorMaxPower,
    maxPower,
  } = importantEquipSpecs;

  const dataMap = [
    { title: "車身型式", data: autoType, classNames: "w-90" },
    {
      title: "動力型式",
      data: energyType === 5 ? { lightData: ["電動"], fullData: [{ tip: "", title: "電動", values: [] }] } : intake,
      classNames: "w-90",
    },
    { title: "最大馬力", data: energyType === 5 ? motorMaxPower : maxPower, classNames: "w-74" },
    { title: energyType === 5 ? "續航" : "變速箱", data: energyType === 5 ? batteryLife : gearBox, classNames: "w-74" },
    {
      title: energyType === 5 ? "能耗" : "油耗",
      data: energyType === 5 ? electricConsumption : fuelConsumption,
      classNames: "w-90",
    },
    { title: "氣囊位置", data: airBag, classNames: "w-74" },
  ];

  return (
    <>
      {dataMap.map((item: any, index) => (
        <Tooltip
          title={
            <>
              {Array.isArray(item.data?.lightData) && !!item.data?.lightData.length
                ? !!item.data?.fullData.length
                  ? item.data?.fullData.map((ii, idx) => (
                      <div key={idx} className={`${idx + 1 === item.data.fullData.length ? "" : "mb-8"} flex flex-col`}>
                        <div className={`text-[#333333] text-12 leading-18 ${!!ii?.values.length ? "mb-4" : ""}`}>
                          {ii.title || ""}
                          {ii?.tip && <span className='text-[#999]'> {ii.tip}</span>}
                        </div>
                        {!!ii?.values.length && (
                          <p className='text-[#999] text-12 leading-18'>{ii.values.join("，")}</p>
                        )}
                      </div>
                    ))
                  : "--"
                : "--"}
            </>
          }
          overlayInnerStyle={{ color: "#333333" }}
          color={"#fff"}
          key={index}
        >
          <div
            className={`text-center ${item.classNames} ${
              index + 1 !== dataMap.length ? "border-0 border-r-1 border-solid border-[#E8E8E8]" : ""
            }`}
          >
            <div className='text-[#666] mb-4'>{item.title}</div>

            <div className='h-34 grid items-center justify-center'>
              {Array.isArray(item.data?.lightData) && !!item.data?.lightData.length
                ? item.data.lightData.map((i, inx) => (
                    <div
                      className='line-clamp-1 px-2 break-all'
                      key={inx}
                      style={{ wordSpacing: 0, wordWrap: "break-word" }}
                    >
                      {i}
                    </div>
                  ))
                : "--"}
            </div>
          </div>
        </Tooltip>
      ))}
      <a
        className='w-78  h-54 rounded-8 text-14 text-primary flex items-center justify-center cursor-pointer hover:text-primary'
        style={{ border: "1px solid #3264FF" }}
        href={`/${setUrlFormat(brandName)}/${setUrlFormat(kindName)}/Specification.html`}
        target='_blank'
      >
        規格配備
      </a>
    </>
  );
};

const ColorList: React.FC<any> = ({ data, setParams }) => {
  const targetRef = useRef<HTMLDivElement>(null);

  const scrollTo = useCallback((scrollValue) => {
    let scrollLeft = targetRef.current!.scrollLeft;
    targetRef.current!.scrollTo(scrollLeft + scrollValue, 0);
  }, []);

  return (
    <div className=''>
      <div className='gap-4 rounded-full  bg-white items-center inline-flex h-24 px-8'>
        {data?.length > 8 && <ArrowLeftIcon size={16} onClick={() => scrollTo(-200)} className='cursor-pointer' />}
        <div
          className='flex scroll-smooth overflow-auto border-box'
          ref={targetRef}
          style={{ maxWidth: "200px", scrollbarWidth: "none", scrollbarColor: "transparent transparent" }}
        >
          <div className='inline-flex gap-12 items-center'>
            {data?.length > 0 &&
              data.map((item, index: number) => (
                <div
                  className='w-14 h-14 rounded-full cursor-pointer'
                  key={index}
                  onClick={() => {
                    setParams({
                      thumb: item.picture,
                    });
                  }}
                  style={{ backgroundColor: item.color, border: "1px solid #BBB" }}
                />
              ))}
          </div>
        </div>
        {data?.length > 8 && <ArrowRightIcon onClick={() => scrollTo(200)} size={16} className='cursor-pointer' />}
      </div>
    </div>
  );
};

const ColorsOrPicture: React.FC<{ data: IKindsPcInfo; setParams: any }> = ({ data, setParams }) => {
  const { pictures, brandName, kindName } = data;

  return (
    <div className='flex justify-between items-center'>
      {pictures.colorPictures.length > 0 ? (
        <ColorList data={pictures.colorPictures} setParams={setParams} />
      ) : (
        <div></div>
      )}

      <div className='text-14 text-black flex gap-40 mr-10'>
        <a
          className='text-center cursor-pointer block'
          target='_blank'
          href={`/${setUrlFormat(brandName)}/${setUrlFormat(kindName)}/HDPhoto.html?typeName=外觀`}
          onClick={(e) => {
            !pictures.pictureCounts.outsideNum && e.preventDefault();
          }}
        >
          <div className='relative font-medium text-14'>
            外觀 <RightFillIcon size={18} fill='#333' className='absolute top-0 -right-16' />
          </div>
          <div className='text-[#666] text-12'>{pictures.pictureCounts.outsideNum || "--"}張</div>
        </a>

        <a
          className='text-center cursor-pointer block'
          target='_blank'
          href={`/${setUrlFormat(brandName)}/${setUrlFormat(kindName)}/HDPhoto.html?typeName=內裝`}
          onClick={(e) => {
            !pictures.pictureCounts.insideNum && e.preventDefault();
          }}
        >
          <div className='relative font-medium text-14'>
            內裝 <RightFillIcon size={18} fill='#333' className='absolute top-0 -right-16' />
          </div>
          <div className='text-[#666] text-12'>{pictures.pictureCounts.insideNum || "--"}張</div>
        </a>

        <a
          className='text-center cursor-pointer block'
          target='_blank'
          href={`/${setUrlFormat(brandName)}/${setUrlFormat(kindName)}/HDPhoto.html?typeName=空間`}
          onClick={(e) => {
            !pictures.pictureCounts.spaceNum && e.preventDefault();
          }}
        >
          <div className='relative font-medium text-14'>
            空間 <RightFillIcon size={18} fill='#333' className='absolute top-0 -right-16' />
          </div>
          <div className='text-[#666] text-12'>{pictures.pictureCounts.spaceNum || "--"}張</div>
        </a>
      </div>
    </div>
  );
};

const KindSumMain: React.FC<{ data: IKindsPcInfo }> = ({ data }) => {
  const [loading, setLoading] = useState(true);
  const [logoLoading, setLogoLoading] = useState(true);
  const [params, setParams] = useSetState({
    thumb: "",
  });
  const { thumb } = params;

  useEffect(() => {
    setParams({
      thumb: data.thumb,
    });
  }, [data.thumb]);

  const { brandLogo, brandName, kindName, rank, visits, year, kindId, favorite } = data;

  return (
    <div id={"KindSumMain"} className='relative w-588'>
      <span
        className='w-1000 h-194 border-1 border-solid border-[#000] absolute bottom-120 z-0'
        style={{
          background: "linear-gradient(180deg,#f2f5ff 0%, #d1d8ec 58%, #b9c2df 77%)",
          filter: "blur(50px)",
          left: -206,
        }}
      ></span>
      <div className='flex justify-between z-1 items-center mb-2'>
        <h1
          className={`${
            `${brandName} ${kindName} ${!!year ? `${year}款` : ""}`.length > 32 ? "text-22 leading-24" : "text-26"
          } flex gap-14 font-medium items-center w-520 my-0`}
        >
          {logoLoading && <Skeleton.Image active style={{ width: "48px", height: "48px" }} />}
          <img
            className={`w-48 h-48 object-cover ${logoLoading ? "hidden" : ""}`}
            src={brandLogo}
            onLoad={() => setLogoLoading(false)}
            alt={`${brandName} ${kindName}`}
          />
          {brandName} {kindName} {!!year ? `${year}款` : ""}
        </h1>
        <AttentionItem kindId={kindId} favorite={favorite} />
      </div>
      <div className='flex items-center gap-20 text-[#999999] text-14 relative z-1'>
        <div className=''>
          車款瀏覽：<span className='text-[#FF4433]'>{formatThousend(visits).replace("萬", "")}</span>
          {visits > 10000 ? "萬" : ""}
        </div>
        {!!data.kindId && data?.importantEquipSpecs?.autoType?.lightData?.length > 0 && (
          <div className=''>
            {data?.importantEquipSpecs?.autoType?.lightData[0]}熱度: 第<span className='text-[#FF4433]'>{rank}</span>名
          </div>
        )}
        {!!data?.rightTips?.content && (
          <div
            className='text-14 text-[#999] flex items-center cursor-pointer'
            onClick={() => {
              if (!!data?.rightTips?.link) {
                window.open(data?.rightTips?.link, "_blank");
              }
            }}
          >
            {data?.rightTips?.content}
            {!!data?.rightTips?.link && <ArrowRightIcon size={32} />}
          </div>
        )}
      </div>
      <div className='mx-auto z-1 sticky my-2 w-470 h-300'>
        {loading && <PlaceHolderImage width={470} height={300} />}
        <a href={`/${setUrlFormat(brandName)}/${setUrlFormat(kindName)}/HDPhoto.html?typeName=外觀`} target='_black'>
          <img
            className={`w-full h-full object-cover ${loading ? "hidden" : ""}`}
            src={thumb}
            onLoad={() => setLoading(false)}
            alt={`${brandName} ${kindName}`}
          />
        </a>
      </div>

      <div id={"Footer"} className=''>
        <ColorsOrPicture data={data} setParams={setParams} />
        <div
          className='w-full h-72 rounded-4 mt-12 text-12 text-black py-10 flex z-1 sticky justify-center'
          style={{
            background: `linear-gradient(180deg,rgba(255,255,255,0.30), rgba(255,255,255,0.80))`,
            boxShadow: `0px 4px 20px 0px rgba(50,100,255,0.10)`,
          }}
        >
          {!!data.kindId && <Specification data={data} />}
        </div>
      </div>
    </div>
  );
};

export default memo(KindSumMain);
